export default __webpack_public_path__ + "static/media/florida.9b2d3379.jpg";